import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { InlineBanner } from "components/ui/inline-banner";
import React from "react";
import { useCurrentTenant } from "store/selectors/hooks";
import { ClientTransferSubject, TransferRow } from "./transfer-types";
import { TransfersPageLink } from "./transfers-page-link";

const transfersPageLead = (transfer: TransferRow): string =>
    transfer.receivedRecordShared
        ? "You can follow their status at the receiving agency on the"
        : "It is listed on the";

export const ClientTransferBanner: React.FC<{
    subject: ClientTransferSubject;
}> = props => {
    const tenant = useCurrentTenant();
    const trpcContext = trpc.useTRPC();
    const query = useQuery(
        trpcContext.clientTransfer.outgoingForSubject.queryOptions({
            subject: props.subject,
        }),
    );

    if (query.data?.status === "Accepted") {
        return (
            <div>
                <InlineBanner type="warning">
                    <p>
                        This client has been transferred to an advisor outside of{" "}
                        {tenant.name}. Consider closing this client.{" "}
                        {transfersPageLead(query.data)} <TransfersPageLink />.
                    </p>
                </InlineBanner>
            </div>
        );
    }

    if (query.data?.status === "Pending") {
        return (
            <div>
                <InlineBanner type="warning">
                    <p>
                        This client is in the process of being transferred to an advisor
                        outside of {tenant.name}.
                    </p>
                </InlineBanner>
            </div>
        );
    }

    return null;
};
